import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import Vue from 'vue';
import appApi from 'api/app';
import auth from '@/utils/auth';
import Moment from 'moment';
var state = {
  themeColor: auth.getThemeColor() || 'Light',
  configData: {},
  jumpUrl: Vue.ls.get('jumpUrl') || '',
  // 需要跳转的外部链接
  requestState: 'init',
  // 省市区json加载状态
  activitiesInfo: [],
  // 活动数据,
  skinChange: '',
  isForwardPage: false,
  // 如果是app通过forward页面打开的不隐藏头
  pushHistoryLength: auth.lsGetMarketHistoryLength() || {
    ORDER: 1,
    CROWD_ORDER: 1
  }
};
var mutations = {
  SET_THEME_COLOR: function SET_THEME_COLOR(state, str) {
    auth.setThemeColor(str);
    state.themeColor = str;
  },
  SET_CONFIG: function SET_CONFIG(state, data) {
    state.configData = data;
  },
  SET_JUMP_URL: function SET_JUMP_URL(state, str) {
    state.jumpUrl = str;
  },
  SET_REQUEST_STATE: function SET_REQUEST_STATE(state, val) {
    state.requestState = val;
  },
  SET_ACTIVITIES_INFO: function SET_ACTIVITIES_INFO(state, val) {
    state.activitiesInfo = val;
  },
  SET_SKIN_CHANGE: function SET_SKIN_CHANGE(state, val) {
    state.skinChange = val;
  },
  SET_FORWARD_PAGE: function SET_FORWARD_PAGE(state, val) {
    state.isForwardPage = val;
  },
  SET_PUSH_HISTORY_LENGTH: function SET_PUSH_HISTORY_LENGTH(state, val) {
    state.pushHistoryLength[val] += 1;
    auth.lsSetMarketHistoryLength(state.pushHistoryLength);
  },
  RESET_PUSH_HISTORY_LENGTH: function RESET_PUSH_HISTORY_LENGTH(state, val) {
    state.pushHistoryLength[val] = 1;
    auth.lsRemoveMarketHistoryLength();
  }
};
var actions = {
  setForwardPage: function setForwardPage(_ref, data) {
    var commit = _ref.commit;
    commit('SET_FORWARD_PAGE', data);
  },
  setPushHistoryLength: function setPushHistoryLength(_ref2, data) {
    var commit = _ref2.commit;
    commit('SET_PUSH_HISTORY_LENGTH', data);
  },
  resetPushHistoryLength: function resetPushHistoryLength(_ref3, data) {
    var commit = _ref3.commit;
    commit('RESET_PUSH_HISTORY_LENGTH', data);
  },
  // 获取通用配置
  GetConfig: function GetConfig(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      appApi.getConfig(null).then(function (response) {
        commit('SET_CONFIG', response);
        localStorage.setItem('prod_config', JSON.stringify({
          expirationTime: Date.now() + 180000,
          value: response
        }));
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 友盟自定义事件PV UV
  ymSelfEvent: function ymSelfEvent(_, data) {
    if (!data) {
      return;
    }

    var id = '';
    var params = {};

    if (typeof data === 'string') {
      id = data;
    } else if (_typeof(data) === 'object') {
      id = data.id;
      params = data.params;
    }

    if (!id) {
      return;
    }

    var _window = window,
        aplus_queue = _window.aplus_queue;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [id, 'CLK', _objectSpread(_objectSpread({}, params), {}, {
        date: Moment().format('YYYY-MM-DD')
      })]
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};